import { render, staticRenderFns } from "./DetailsView.vue?vue&type=template&id=5a9dc17a&scoped=true&"
import script from "./DetailsView.vue?vue&type=script&lang=js&"
export * from "./DetailsView.vue?vue&type=script&lang=js&"
import style0 from "./DetailsView.vue?vue&type=style&index=0&id=5a9dc17a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a9dc17a",
  null
  
)

export default component.exports